(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info/assets/product-odds/product-odds.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info/assets/product-odds/product-odds.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  selectEventStatisticByType,
  selectEventStatisticCurrentValueByType
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  TableComponent
} = svs.components.sportinfo.matchInfoComponents;
const {
  EventTypeId,
  EventTypeField,
  EventTypeDistributionsFallback
} = svs.components.sportinfo.common.constants;
const {
  createEventStatisticsKey
} = svs.components.sportinfo.common.helpers;
const {
  getOutcomeLabelsForEventType,
  getOutcomeCount
} = svs.components.sport.tipsenShared;
const {
  SportTypes
} = svs.components.sport.sportTypes;
const {
  productIds,
  getDisplayName
} = svs.utils.products;
const distributionProductMapping = {
  challenge: 'Challenge',
  europatipset: 'Europatipset',
  powerplay: 'Powerplay',
  stryktipset: 'Stryktipset',
  topptipset: 'Topptipset',
  topptipsetextra: 'Topptipset europa',
  topptipsetstryk: 'Topptipset stryk'
};
const {
  Odds: formatOdds
} = svs.utils.format;
const ProductOdds = _ref => {
  let {
    betEvent,
    matchId,
    eventTypeId = EventTypeId.EVENT_1X2
  } = _ref;
  const sportType = SportTypes.Soccer;
  const eventStatisticsKey = createEventStatisticsKey({
    matchId,
    eventTypeId,
    periodNumber: betEvent.periodNumber,
    eventNumber: betEvent.eventNumber
  });
  const distributions = useSelector(state => selectEventStatisticByType(state, eventStatisticsKey, EventTypeField.Distributions));
  const startOdds = useSelector(state => selectEventStatisticCurrentValueByType(state, eventStatisticsKey, EventTypeField.StartOdds));
  let odds = useSelector(state => selectEventStatisticCurrentValueByType(state, eventStatisticsKey, EventTypeField.Odds));
  if (eventTypeId === EventTypeId.HEAD_TO_HEAD) {
    odds = startOdds;
  }
  if (odds.length === 0) {
    odds = new Array(getOutcomeCount(EventTypeId.EVENT_1X2)).fill(null);
  }
  const outcomeLabels = getOutcomeLabelsForEventType(eventTypeId, sportType);
  const distribution = [];
  if (distributions) {
    const mappedProductName = productName => {
      switch (productName) {
        case productIds.T8STRYK:
          return 'Topptipset stryk';
        case productIds.T8EXTRA:
          return 'Topptipset europa';
        default:
          return typeof productName === 'number' ? getDisplayName(productName) : distributionProductMapping[productName];
      }
    };
    Object.keys(distributions).sort((a, b) => a - b).forEach(did => {
      var _distributions$did$Ev, _distributions$did$Ev2, _distributions$did$Ev3;
      distribution.push({
        key: did,
        productName: mappedProductName(parseInt(did, 10)),
        one: (_distributions$did$Ev = distributions[did][EventTypeDistributionsFallback]) === null || _distributions$did$Ev === void 0 ? void 0 : _distributions$did$Ev.current.value[0],
        x: (_distributions$did$Ev2 = distributions[did][EventTypeDistributionsFallback]) === null || _distributions$did$Ev2 === void 0 ? void 0 : _distributions$did$Ev2.current.value[1],
        two: (_distributions$did$Ev3 = distributions[did][EventTypeDistributionsFallback]) === null || _distributions$did$Ev3 === void 0 ? void 0 : _distributions$did$Ev3.current.value[2]
      });
    });
  }
  return React.createElement(TableComponent, {
    ariaDescription: "Spelf\xF6rdelning och odds p\xE5 matchen",
    className: "match-info-product-odds"
  }, React.createElement(TableComponent.Header, null, React.createElement(TableComponent.Header.Row, {
    className: "match-info-product-odds-row"
  }, React.createElement(TableComponent.Header.Row.ContentCell, null), outcomeLabels && outcomeLabels.map((labels, i) => React.createElement(TableComponent.Header.Row.HeaderCell, {
    className: "product-odds-cell-heading",
    key: i,
    scope: "col"
  }, labels.text, ' ')))), React.createElement(TableComponent.Body, null, odds.length > 0 && React.createElement(TableComponent.Body.Row, {
    className: "match-info-product-odds-row"
  }, React.createElement(TableComponent.Body.Row.HeaderCell, {
    scope: "row"
  }, React.createElement("div", {
    className: "product-odds-label"
  }, React.createElement("div", {
    className: "product-odds-rowheading"
  }, "Oddset"), eventTypeId === EventTypeId.HEAD_TO_HEAD && React.createElement("div", {
    className: "product-odds-sub-rowheading"
  }, "Startodds"))), odds && odds.map((odd, i) => React.createElement(TableComponent.Body.Row.ContentCell, {
    key: i
  }, ' ', formatOdds(odd) || '-', ' '))), distribution.map(_ref2 => {
    let {
      key,
      productName,
      one,
      x,
      two
    } = _ref2;
    return React.createElement(TableComponent.Body.Row, {
      className: "match-info-product-odds-row",
      key: key
    }, React.createElement(TableComponent.Body.Row.HeaderCell, {
      scope: "row"
    }, React.createElement("div", {
      className: "product-odds-label"
    }, React.createElement("div", {
      className: "product-odds-rowheading"
    }, productName), React.createElement("div", {
      className: "product-odds-sub-rowheading"
    }, "Svenska Folket"))), React.createElement(TableComponent.Body.Row.ContentCell, null, one ? "".concat(one, "%") : '-'), React.createElement(TableComponent.Body.Row.ContentCell, null, x ? "".concat(x, "%") : '-'), React.createElement(TableComponent.Body.Row.ContentCell, null, two ? "".concat(two, "%") : '-'));
  })));
};
setGlobal('svs.components.sportinfo.matchInfo.ProductOdds', ProductOdds);

 })(window);